import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService, App } from 'src/app/services/app-config.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-landing-page',
  templateUrl: 'component.html',
  styleUrls: ['component.scss'],
  providers: [MessageService], 
})
export class LandingPageComponent {
  apps: App[] = [];
  errorMessage: string | null = null;

  constructor(
    private router: Router,
    private appConfigService: AppConfigService,
    private messageService: MessageService
  ) {
    this.loadApps();
  }

  loadApps(): void {
    try {
      this.apps = this.appConfigService.getApps();
      this.messageService.add({
        severity: 'success',
        summary: 'Applications Loaded',
        detail: 'Applications were loaded successfully.',
      });
    } catch (error) {
      this.errorMessage = 'Failed to load applications.';
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: this.errorMessage,
      });
      console.error(error);
    }
  }

  navigateTo(url: string): void {
    try {
      this.router.navigateByUrl(url);
      this.messageService.add({
        severity: 'info',
        summary: 'Navigation',
        detail: `Navigated to ${url}`,
      });
    } catch (error) {
      this.errorMessage = 'Navigation failed.';
      this.messageService.add({
        severity: 'error',
        summary: 'Navigation Error',
        detail: this.errorMessage,
      });
      console.error(error);
    }
  }
}
